import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconMachineUser }  from '../../assets/icons/icon_machine_user.svg';

const ConstructorIcon=(props)=>{
    return <Icon component={() => <IconMachineUser />} {...props}/>
}

export default ConstructorIcon;